import { default as Alert } from './Alert';
import { default as BodyEmpty } from './BodyEmpty';
import { default as Standard } from './Standard';

const EXPORT = { Alert, BodyEmpty, Standard };

export default EXPORT;
